import { render } from "./FriendComponent.vue?vue&type=template&id=7917a952"
import script from "./FriendComponent.vue?vue&type=script&lang=js"
export * from "./FriendComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__